import { IEventsState } from "./IEventsState";

export const initialEventsState: IEventsState = {
    events: []
};
